import React, { useState, useEffect } from "react";

const RaiseHandButton = ({handRaised, handBroughtDown, raiseHandState}) => {
  const [isHighlighted, setIsHighlighted] = useState(false);

  const handleClick = () => {
    if(!isHighlighted){
      handRaised();
      setIsHighlighted((prevState) => !prevState);
    }
  };

  useEffect(() => {
    setIsHighlighted(raiseHandState);
  }, [raiseHandState]);

  return (
    <>
    {<button
      onClick={handleClick}
      style={{
        height: "40px",
        width: "40px",
        borderRadius: "50%",
        border: isHighlighted ? "2px solid rgba(240,173,78,0.8)" : "none",
        background: isHighlighted ? "rgba(240,173,78,0.35)" : "rgba(255,255,255,0.18)",
        backdropFilter: "blur(6px)",
        cursor: "pointer",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "18px",
        transition: "all 0.25s ease",
        boxShadow: isHighlighted ? "0 0 12px rgba(240,173,78,0.5)" : "none",
        flexShrink: 0,
      }}
    >
      <span role="img" aria-label="Raise Hand">✋</span>
    </button>}
    </>
  );
};

export default RaiseHandButton;
